module.exports = __webpack_public_path__ + "static/media/RahulReddy.1f935d18.jpg";